<!--
 * @Author: Louis
 * @Date: 2020-02-18 18:01:55
 * @LastEditors: Louis
 * @LastEditTime: 2020-02-18 18:05:21
 * @Description:
 -->
<template>
  <div class="en-input">
    <div
      class="tips"
      :class="{'is-disabled': disabled || fullData.disabled}"
      v-if="(
            parseInt(fullData.ruleGenerateType, 10) === 2 ||
            parseInt(fullData.ruleGenerateType, 10) === 3) &&
            fullData.codeRule.length > 0"
    >
      {{ inputValue ? inputValue : '自动生成' }}
    </div>
    <textarea
      class="textarea input-container"
      :readonly="disabled || fullData.disabled"
      :class="{'with-suffix': fullData.suffix && fullData.suffix !== ''}"
      v-if="
        parseInt(fullData.fieldType,10) !== 4 &&
        parseInt(fullData.fieldType,10) !== 3 &&
        !((
        parseInt(fullData.ruleGenerateType, 10) === 2 ||
        parseInt(fullData.ruleGenerateType, 10) === 3) &&
        fullData.codeRule.length > 0)"
      @keyup="changeValueInfo"
      ref="inputContainer"
      :style="{'height':inputHeight + 'px'}"
      v-model="inputValue"
      placeholder="请输入"
      maxlength="140"
    >
    </textarea>
    <textarea
      :readonly="disabled || fullData.disabled"
      v-if="(
        parseInt(fullData.fieldType,10) === 4 ||
        parseInt(fullData.fieldType,10) === 3)  &&
        !((
        parseInt(fullData.ruleGenerateType, 10) === 2 ||
        parseInt(fullData.ruleGenerateType, 10) === 3) &&
        fullData.codeRule.length > 0)"
      :style="{'height':inputHeight + 'px'}"
      v-model="inputValue"
      @keyup="changeValueInfo"
      placeholder="请输入"
      ref="inputContainer"
      maxlength="140"
      class="input-container textarea"
    >
    </textarea>
    <div
      class="suffix"
      :class="{'is-disabled': disabled || fullData.disabled}"
      v-if="fullData.suffix && fullData.suffix !== ''"
    >
      {{
      parseInt(fullData.suffix,10) === 1 ||
      parseInt(fullData.suffix) === 2 ?
      parseInt(fullData.suffix,10) === 1 ? "元" :
      parseInt(fullData.suffix,10) === 2 ? "万元" :
      fullData.suffix : fullData.suffix
      }}
    </div>
    <en-tips
      v-model="showTips"
      :tips="message"
    >
    </en-tips>
  </div>
</template>
<script>
import enTips from "./../en-tips";

export default {
  name: "enInput",
  components: {enTips},
  props: {
    value: {
      default: ""
    },
    fullData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTips: false,
      message: "",
      inputHeight: 50,
      inputValue: null,
      needEmit: false
    };
  },
  mounted() {
    this.inputValue = this.value ? this.value : null
    this.fullData._setValue = (val) => {
      this.setValue(val)
    }
    this.$nextTick(() => {
      this.needEmit = true;
    })
  },
  methods: {
    /**
     * @description 检测是否为合法的数值/金额数据
     */
    checkValue() {
      if (this.inputValue && !/^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(this.inputValue)) {
        this.showTips = true;
        this.message = this.fullData.name + "数据填写有误，请重新填写";
      }
    },
    /**
     * @description 输入时，动态增加输入框高度
     */
    changeValueInfo() {
      this.inputHeight = 50;
      setTimeout(() => {
        this.inputHeight = this.$refs.inputContainer.scrollHeight;
      }, 15);
    },
    /**
     * @description 重设输入框数据
     * @param val
     */
    setValue(val) {
      this.inputValue = val;
    }
  },
  watch: {
    /**
     * @description 当填写的数据发生变更时，进行回调，给计算公式进行数据处理
     * @param nVal
     */
    inputValue(nVal) {
      if (!this.needEmit) {
        return
      }
      this.$emit('input', nVal)
      this.$emit("change", this.fullData);
    },
    value: {
      handler(val) {
        this.setValue(val)
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
  .en-input {
    display: flex;
    justify-content: flex-end;
    text-align: right;

    .content {
      width: 100%;
    }

    .tips {
      font-size: 14px;
      text-align: right;
      color: #C7C7CC;
      width: 100%;
      padding: 0;

      &.is-disabled {
        color: #333333;
        background-color: #f9f9f9;
      }
    }

    .input-container {
      border: none;
      outline: none;
      height: 50px;
      line-height: 30px;
      padding: 10px 0;
      text-align: right;
      font-size: 14px;
      color: #848484;
      width: 100%;

      &:read-only {
        color: #333333;
        opacity: 1;
        background-color: #f9f9f9;
      }

      &::placeholder {
        color: #C7C7CC;
      }

      &.with-suffix {
        width: auto;
      }
    }

    .suffix {
      white-space: nowrap;
      color: #848484;

      &.is-disabled {
        color: #333333;
        background-color: #f9f9f9;
      }
    }
  }
</style>
